import Vue from 'vue';

import { Snackbar } from '@/components';

const SnackbarConstructor = Vue.extend(Snackbar);
export const snackbar = (options = {}) => {
  const count = document.getElementsByClassName('snackbar')?.length || 0;
  const snackbarInstance = new SnackbarConstructor({
    data: { ...options, id: count },
  });

  const block = document.createElement('div');
  document.body.appendChild(block);
  snackbarInstance.$mount(block);

  return snackbarInstance;
};

export default {
  install(vue) {
    if (vue.installed) return;
    // eslint-disable-next-line no-param-reassign
    vue.installed = true;

    // eslint-disable-next-line no-param-reassign
    vue.prototype.$snackbar = snackbar;
  },
};
